// Copyright (c) 2026 Solartek LLC. All rights reserved.
import { z } from 'zod';
import { SYNC_ITEM_STATUSES } from '../enums.js';
import { paginationQuerySchema, uuidSchema } from '../common.js';
export const syncDeviceScopeSchema = z.object({
    deviceIds: z.array(uuidSchema).max(1000).optional(),
    branchId: uuidSchema.optional(),
    groupId: uuidSchema.optional(),
    all: z.boolean().default(false),
}).refine((v) => v.all || v.branchId || v.groupId || (v.deviceIds && v.deviceIds.length > 0), { message: 'Specify devices, a branch, a group, or all' });
export const syncHealthCheckRequestSchema = syncDeviceScopeSchema;
export const syncReconcileRequestSchema = z.object({
    deviceIds: z.array(uuidSchema).max(1000).optional(),
    branchId: uuidSchema.optional(),
    groupId: uuidSchema.optional(),
    all: z.boolean().default(false),
    /** Create repair jobs (push/delete) for the differences found. */
    repair: z.boolean().default(false),
}).refine((v) => v.all || v.branchId || v.groupId || (v.deviceIds && v.deviceIds.length > 0), { message: 'Specify devices, a branch, a group, or all' });
export const syncJobItemsQuerySchema = paginationQuerySchema.extend({ status: z.enum(SYNC_ITEM_STATUSES).optional(), deviceId: uuidSchema.optional() });
export const reconciliationQuerySchema = z.object({ branchId: uuidSchema.optional(), deviceId: uuidSchema.optional() });
//# sourceMappingURL=sync.js.map